import React from "react";
import { PlusIcon } from "@heroicons/react/24/outline";
import Select from "components/ui/Select";
import useModalStore from "store/modals";
import { useAllAreas } from "http-hooks/area/useArea";

const SelectAreas = ({
  value,
  onChange,
  placeholder = "Select Area",
  isDisabled = false,
  isRequired = false,
  isMulti = false,
  label = "Area",
  className = "",
  filters = {},
  showLabel = true,
  showAddButton = true,
  isClearable = true,
}) => {
  const { openModal } = useModalStore();

  const {
    isLoading: isLoadingAreas,
    data: { data: allAreas } = [],
  } = useAllAreas({
    ag_status: 1,
    noPagination: true,
    ...filters,
  });

  const handleAddNew = () => {
    openModal("area");
  };

  return (
    <div>
      {showLabel && (
        <div className="flex items-center justify-between mb-2">
          <label className="block text-sm font-medium leading-6 text-gray-900">
            {label} {isRequired && <span className="text-red-500">*</span>}
          </label>
          {showAddButton && !isDisabled && (
            <button
              type="button"
              onClick={handleAddNew}
              className="ml-2 p-1 text-xs font-bold bg-black text-white rounded hover:bg-gray-800 transition-colors duration-200 flex items-center"
              title="Add new area"
            >
              <PlusIcon className="h-3 w-3" aria-hidden="true" />
            </button>
          )}
        </div>
      )}
      <Select
        value={value}
        onChange={onChange}
        options={allAreas}
        getOptionValue={(option) => option?.areaId}
        getOptionLabel={(option) => option?.areaname}
        placeholder={placeholder}
        isDisabled={isDisabled}
        isLoading={isLoadingAreas}
        isRequired={isRequired}
        isMulti={isMulti}
        label={label}
        className={className}
        showLabel={false}
        isClearable={isClearable}
        isSearchable={true}
      />
    </div>
  );
};

export default SelectAreas;
